import { Form, InputNumber, Select, Input, Button, Typography, message } from 'antd';
import { useCreateExpense } from 'hooks/api';

const { Title } = Typography;
const { Option } = Select;

const PERSONS = [
  { label: 'Влад', value: 'Влад' },
  { label: 'Коля', value: 'Коля' },
];

const ExpenseCreate = () => {
  const [form] = Form.useForm();
  const { mutateAsync, isLoading } = useCreateExpense();

  const onFinish = async (values: { amount: number; person?: string; description?: string }) => {
    await mutateAsync({
      amount: values.amount,
      person: values.person || undefined,
      description: values.description || undefined,
    });
    message.success('Витрату додано');
    form.resetFields();
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <Title level={2}>Додати витрату</Title>
      <Form form={form} layout='vertical' onFinish={onFinish}>
        <Form.Item
          label='Сума (грн)'
          name='amount'
          rules={[{ required: true, message: 'Введіть суму' }]}
        >
          <InputNumber style={{ width: '100%' }} min={0} placeholder='0' />
        </Form.Item>

        <Form.Item label='Хто витратив' name='person'>
          <Select allowClear placeholder='Не вказано'>
            {PERSONS.map((p) => (
              <Option key={p.value} value={p.value}>{p.label}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label='Опис' name='description'>
          <Input.TextArea rows={3} placeholder='Опис витрати...' />
        </Form.Item>

        <Form.Item>
          <Button type='primary' htmlType='submit' loading={isLoading}>
            Зберегти
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ExpenseCreate;
